import { ActionKey, ItemMenuProps } from '../Types'
import { useRemovable } from './hooks/useRemovable'
import { useItemContextMenu } from './hooks/useItemContextMenu'
import { useEditable } from './hooks/useEditable'
import { handbookFullUrl } from 'components/Handbook2_0/util'
import { useLinkable } from './hooks/useLinkable'
import { useCopyable } from './hooks/useCopyable'
import { useHandbookItems } from 'components/Handbook2_0/Sidebar/HandbookItemProvider'
import { BaseMenu } from '../BaseMenu'
import { useShareable } from './hooks/useShareable'
import { useFavoritable } from './hooks/useFavoritable'
import { useMovable } from './hooks/useMovable'

export const DocItemMenu = (props: ItemMenuProps) => {
  const { item, onEdit } = props
  const { shareable, handleShareable } = useShareable(item)
  const { favoritable, handleFavorite } = useFavoritable(item)
  const { currentHandbook: handbook } = useHandbookItems()

  // TODO: handbook *should* always be available at this point, but React re-renders have proven me wrong before
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { linkable, handleLinkable } = useLinkable(handbookFullUrl(handbook!, item.document?.seo_string), {
    copyLink: 'Copy link',
  })
  const { copyable, openCopyModal: handleCopy } = useCopyable(item, 'Make a copy')
  const { movable, handleMove } = useMovable(item, 'Move')
  const { editable, handleEdit } = useEditable(item, 'Rename', onEdit)
  const { removable, handleRemove } = useRemovable(item, 'Remove doc')

  const { visible, setVisible, handleAction } = useItemContextMenu({
    handlers: [handleRemove, handleEdit, handleLinkable, handleCopy, handleShareable, handleMove, handleFavorite],
  })

  const disabledKeys = new Set<ActionKey>()
  if (handbook?.current_user_access && ['read', 'comment'].includes(handbook.current_user_access)) {
    disabledKeys.add(ActionKey.delete)
    disabledKeys.add(ActionKey.edit)
    disabledKeys.add(ActionKey.move)
    disabledKeys.add(ActionKey.addToTemplates)
  }

  const menus = [
    [linkable.newTab],
    favoritable,
    [...shareable, linkable.copyLink, ...movable, ...copyable, ...editable, ...removable],
  ]

  return (
    <>
      <BaseMenu
        menus={menus}
        handleAction={handleAction}
        visible={visible}
        setVisible={setVisible}
        disabledKeys={disabledKeys}
        {...props}
      />
    </>
  )
}
